// field names
export const DEVICE = 'device';
export const SUPPRESSED = 'suppressed';
export const TIMESTAMP = 'timestamp';
export const FORMAT_VERSION = 'format_version';
export const DATE = 'date';
